module.exports = __webpack_public_path__ + "img/woman-body-upper-back.292cea79.png";